import { type DashboardWidget, type ReportDateRange } from '@terros/common'

export function getEffectiveWidgetDateRange(
  widget: DashboardWidget,
  dashboardDateRange: ReportDateRange | undefined
): ReportDateRange | undefined {
  return widget.dateRange ?? dashboardDateRange
}
